var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import SportsSoccerIcon from "@mui/icons-material/SportsSoccer";
import WarningIcon from "@mui/icons-material/Warning";
import { Box, Card, CardContent, Link, Stack, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
export var StatsStack = function (_a) {
    var stats = _a.stats;
    var mostCapped = __spreadArray([], __read(stats), false).sort(function (a, b) { return b.matchesPlayed - a.matchesPlayed; })[0];
    var topScorer = __spreadArray([], __read(stats), false).sort(function (a, b) { return b.goalsScored - a.goalsScored; })[0];
    var dirtiest = __spreadArray([], __read(stats), false).sort(function (a, b) {
        return b.redCards !== a.redCards
            ? b.redCards - a.redCards
            : b.yellowCards - a.yellowCards;
    })[0];
    var cards = [
        {
            label: "Most Capped",
            icon: _jsx(EmojiEventsIcon, { fontSize: "large" }),
            value: mostCapped ? "".concat(mostCapped === null || mostCapped === void 0 ? void 0 : mostCapped.matchesPlayed, " games") : "",
            player: mostCapped === null || mostCapped === void 0 ? void 0 : mostCapped.player,
        },
        {
            label: "Top Scorer",
            icon: _jsx(SportsSoccerIcon, { fontSize: "large" }),
            value: topScorer ? "".concat(topScorer === null || topScorer === void 0 ? void 0 : topScorer.goalsScored, " goals") : "",
            player: topScorer === null || topScorer === void 0 ? void 0 : topScorer.player,
        },
        {
            label: "Dirtiest Player",
            icon: _jsx(WarningIcon, { fontSize: "large", color: "error" }),
            value: dirtiest
                ? "".concat(dirtiest === null || dirtiest === void 0 ? void 0 : dirtiest.redCards, " red / ").concat(dirtiest === null || dirtiest === void 0 ? void 0 : dirtiest.yellowCards, " yellow")
                : "",
            player: dirtiest === null || dirtiest === void 0 ? void 0 : dirtiest.player,
        },
    ];
    return (_jsxs(_Fragment, { children: [_jsx(Stack, { spacing: 2, sx: { flexWrap: "wrap" }, children: cards.map(function (card) {
                    var _a;
                    return (_jsx(Card, { sx: { minWidth: 200, flex: 1 }, children: _jsx(CardContent, { children: _jsxs(Stack, { spacing: 1, alignItems: "center", children: [card.icon, _jsx(Typography, { variant: "h6", children: card.label }), _jsx(Typography, { variant: "subtitle1", fontWeight: "bold", children: ((_a = card.player) === null || _a === void 0 ? void 0 : _a.name) || "N/A" }), _jsx(Typography, { variant: "body2", color: "text.secondary", children: card.value })] }) }) }, card.label));
                }) }), _jsx(Box, { mt: 2, display: "flex", justifyContent: "flex-end", children: _jsx(Link, { to: "stats", component: RouterLink, underline: "hover", variant: "body2", children: "See Full Stats \u2192" }) })] }));
};
